import pageUnloadEvent from 'constants/page-unload-event';
import { dataLayer } from 'analytics/data-layer';

const addPageUnloadListener = () =>
  window.addEventListener('beforeunload', () => dataLayer.push(pageUnloadEvent));

export default addPageUnloadListener;
